import React, { useState } from "react";
import { MdOutlineEdit } from "react-icons/md";
import Select from "react-select";
import styles from "../../CreateProvider/CreateProvider.module.css";
import {
  EditProviderFeilds,
  EditToolFeids,
  ProviderTypeOptions,
  ToolTypeOptions,
} from "../../../Utils/constants";
import { editProviderTool } from "../../../Services/Provider/providerService";
import Loader from "../../Loader";

const EditProviderTool = ({
  selectedProviderTool,
  onClose,
  type,
  providerId,
  setErrorMessage,
}) => {
  const [providerTool, setProviderTool] = useState(selectedProviderTool);
  const [isEditing, setIsEditing] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setProviderTool({ ...providerTool, [name]: value });
  };

  const handleEditToggle = () => {
    setIsEditing(!isEditing);
  };

  const handleSave = (e) => {
    e.preventDefault();
    setIsLoading(true);
    setErrorMessage("");
    const changedFields = Object.keys(providerTool).reduce((acc, key) => {
      if (providerTool[key] !== selectedProviderTool[key]) {
        acc[key] = providerTool[key];
      }
      return acc;
    }, {});
    const payload = {
      input: {
        entityType: type === "Provider" ? "Provider" : "Tool",
        id: providerTool?.id,
        attributesToPatch: {
          ...changedFields,
        },
      },
    };
    editProviderTool(payload)
      .then((res) => {
        setIsLoading(false);
        if (res?.data?.status === 200) {
          setIsEditing(false);
          onClose("success");
        } else {
          setErrorMessage(
            res?.response?.data?.errorMessage ||
              res?.message ||
              "Something went wrong"
          );
        }
      })
      .catch((err) => {
        setIsLoading(false);
        setErrorMessage("Something went wrong");
      });
  };

  return (
    <>
      {isLoading && <Loader />}
      <div style={{ maxWidth: "600px", paddingInline: "20px" }}>
        <div
          className="flex items-center justify-end my-2 text-sm"
          onClick={handleEditToggle}
          style={{ cursor: "pointer", color: "#47B7CF" }}
        >
          <MdOutlineEdit className="text-lg" />
          <span>Edit Details</span>
        </div>
        <form onSubmit={handleSave}>
          {(type === "Provider" ? EditProviderFeilds : EditToolFeids).map(
            (field) => (
              <div
                key={field.id}
                style={{
                  display: "flex",
                  alignItems: "center",
                  marginBottom: "16px",
                }}
              >
                <label
                  htmlFor={field.id}
                  style={{ flex: "1", textAlign: "left", fontWeight: "bold" }}
                >
                  {field.label}:{" "}
                  {field.required && <span className="text-red-700">*</span>}
                </label>
                {field.type === "select" ? (
                  <Select
                    id={field.id}
                    isDisabled={!field.isEdit || !isEditing}
                    required={field.required}
                    defaultValue={(type === "Provider"
                      ? ProviderTypeOptions
                      : ToolTypeOptions
                    ).find((option) => option.value === providerTool[field.id])}
                    options={
                      type === "Provider"
                        ? ProviderTypeOptions
                        : ToolTypeOptions
                    }
                    onChange={(selectedOption) =>
                      setProviderTool({
                        ...providerTool,
                        [field.id]: selectedOption?.value || "",
                      })
                    }
                    styles={{
                      control: (baseStyles) => ({
                        ...baseStyles,
                        width: 420,
                        border:
                          isEditing && field.isEdit ? "1px solid #ccc" : "none",
                        backgroundColor:
                          isEditing && field.isEdit ? "white" : "#f9f9f9",
                      }),
                    }}
                  />
                ) : field.type === "textarea" ? (
                  <textarea
                    id={field.id}
                    name={field.id}
                    value={providerTool[field.id]}
                    onChange={handleInputChange}
                    disabled={!field.isEdit || !isEditing}
                    required={field.required}
                    style={{
                      flex: "3",
                      border:
                        isEditing && field.isEdit ? "1px solid #ccc" : "none",
                      borderRadius: "5px",
                      backgroundColor:
                        isEditing && field.isEdit ? "white" : "#f9f9f9",
                      padding: "8px",
                    }}
                  />
                ) : (
                  <input
                    type={field.type}
                    id={field.id}
                    name={field.id}
                    value={providerTool[field.id]}
                    onChange={handleInputChange}
                    disabled={!field.isEdit || !isEditing}
                    required={field.required}
                    style={{
                      flex: "3",
                      border:
                        isEditing && field.isEdit ? "1px solid #ccc" : "none",
                      borderRadius: "5px",
                      backgroundColor:
                        isEditing && field.isEdit ? "white" : "#f9f9f9",
                      padding: "8px",
                    }}
                  />
                )}
              </div>
            )
          )}

          <div className="flex items-center justify-center">
            <button
              type="submit"
              style={{
                opacity: !isEditing ? 0.5 : 1,
              }}
              className={`${styles.submit} !mt-2 !p-2`}
              disabled={!isEditing}
            >
              Save Changes
            </button>
          </div>
        </form>
      </div>
    </>
  );
};

export default EditProviderTool;
